import { useContext } from 'react';
import { EntityPluginTenancyinformationContent } from '@comcastdevxplatforms/plugin-tenancyinformation';
import { UserContext } from '../../contexts/UserContext';

/**
 * DeviceListPage Component - Displays a list of devices
 * @returns JSX.Element
 */
export const CnapTenancy = () => {
  const { login } = useContext(UserContext);
  return <EntityPluginTenancyinformationContent user={login} />;
};
